import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { fetchSeasons } from './api.ts';

interface SeasonSelect {
  /** Available seasons, newest first. Null while loading. */
  seasons: number[] | null;
  /** The season currently being viewed. */
  selected: number | null;
  setSelected: (season: number) => void;
}

const Ctx = createContext<SeasonSelect>({ seasons: null, selected: null, setSelected: () => {} });

/**
 * Holds which season the whole app is showing. Lifted above the router so the
 * nav's season switcher and the data loader read the same state — picking 2023
 * in the nav reloads every page against 2023.
 */
export function SeasonSelectProvider({ children }: { children: ReactNode }) {
  const [seasons, setSeasons] = useState<number[] | null>(null);
  const [selected, setSelected] = useState<number | null>(null);

  useEffect(() => {
    fetchSeasons()
      .then((s) => {
        setSeasons(s);
        setSelected((cur) => cur ?? s[0] ?? null);
      })
      .catch(() => setSeasons([]));
  }, []);

  return <Ctx.Provider value={{ seasons, selected, setSelected }}>{children}</Ctx.Provider>;
}

export function useSeasonSelect() {
  return useContext(Ctx);
}
